import {FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {isDate, isNumeric} from "rxjs/internal-compatibility";
import {DxDateTime} from "./dx-core-datetime-utils";
import {DxCoreUtils} from "./dx-core-utils";
import {isEmpty} from "rxjs/operators";

/**
 * локализация стандартных валидаторов.
 * Можно добавить кастумные сообщения через {@link DxBaseControlComponent.errorMessages}
 * для конкретного компонента
 */
export const VALIDATION_ERROR_MESSAGES = new Map([
  ['required', 'Необходимо заполнить поле'],
  ['pattern', 'Значение не соответствует шаблону'],
  ['number', 'Введите число с разделителем (.) или целое'],
  ['date', 'Дата указана не верно. Нужен формат: ' + DxDateTime.dateTimeFormats.date],
  ['time', 'Время указано не верно. Нужен формат: ' + DxDateTime.dateTimeFormats.time],
  //['minlength', 'Должно быть введено не менее ' + errors.minlength.requiredLength + ' символов']
  //['maxlength', 'Должно быть введено не более ' + errors.maxlength.requiredLength + ' символов']
]);

/**
 * WARNING: не работает без FormGroup!
 */
export class DxValidators {

  static predicate: ((statement: () => boolean, validators: ValidatorFn[]) => ValidatorFn) = (statement, validators) => {
    return (control) => {
      return statement() ? Validators.compose(validators)(control) : null;
    };
  }

  static number: ValidatorFn = (control) => {
    return !DxValidators.inputValue(control) || isNumeric(control.value) ?
           null :
           {
              number: true
           };
  };

  static date: ValidatorFn = (control) => {
    return !DxValidators.inputValue(control) || isDate(control.value) ?
      null :
      {
        date: true
      };
  };

  static time: ValidatorFn = (control) => {
    return !DxValidators.inputValue(control) || isDate(control.value) ?
      null :
      {
        time: true
      };
  };


  static inputValue(control): string {
    const elName = DxCoreUtils.getControlId(control);
    if (!elName) {
      return null;
    }
    const el = document.querySelector('input[name='+elName+']') as HTMLInputElement;
    if (!el) {
      return null;
    }
    return el.value;
  }
}
